{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "API",
      "folder": "Well Header",
      "isShownByDefault": true,
      "tnum": true,
    },
    "gpt": {
      "hint": "API / Well Identifier stored in DB as a compact 14-character string with no separators. RULE: If the user provides any API-like token, filter using internal_id ONLY. Normalize user input by removing all non-alphanumeric characters. Preserve leading zeros. SQL: internal_id = <normalized> (or IN (...) for multiple). Do not use lease_well_name or lease_number for API searches.",
    },
  },
  "lease_well_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Well Name",
      "folder": "Well Header",
      "width": 220,
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Use this field for explicit well-name searches. Do not use it for API searches.",
    },
  },
  "state": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "Alaska",
        "Arkansas",
        "Colorado",
        "Kansas",
        "Louisiana",
        "Mississippi",
        "Montana",
        "New Mexico",
        "North Dakota",
        "Oklahoma",
        "Ohio",
        "Pennsylvania",
        "Texas",
        "Utah",
        "West Virginia",
        "Wyoming",
      ],
    },
    "ui": {
      "label": "State",
      "folder": "Well Header",
      "isShownByDefault": true,
    },
  },
  "county": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "County",
      "folder": "Well Header",
    },
  },
  "lease_number": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Lease Number",
      "folder": "Well Header",
      "tnum": true,
    },
    "gpt": {
      "hint": "Lease number field. Use only when the user explicitly asks for a lease number. Do not assume consistent formatting across states.",
    },
  },
  "current_operator_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Operator",
      "folder": "Well Header",
      "width": 225,
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Use this column when a company name is mentioned unless specified otherwise",
    },
  },
  "well_status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "State Status",
      "folder": "Well Header",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "well_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "State Type",
      "folder": "Well Header",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "pn_well_status": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "Abandoned",
        "Active",
        "Cancelled",
        "Confidential",
        "Licenced",
        "Location",
        "Suspended",
        "Drilled",
        "Unknown",
      ],
    },
    "ui": {
      "label": "Well Status",
      "folder": "Well Header",
      "isShownByDefault": true,
    },
  },
  "pn_well_type": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "Confidential",
        "Disposal",
        "Drainage",
        "Injection",
        "Observation",
        "Oil Sand Evaluation",
        "Production",
        "Source",
        "Storage",
        "Other",
        "Unknown",
      ],
    },
    "ui": {
      "label": "Well Type",
      "folder": "Well Header",
    },
  },
  "pn_well_fluid": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["Confidential", "Gas", "None", "Oil", "Other", "Water"],
    },
    "ui": {
      "label": "Well Fluid",
      "folder": "Well Header",
    },
  },
  "trajectory": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["Horizontal", "Vertical", "Directional", "Slant"],
    },
    "ui": {
      "label": "Trajectory",
      "folder": "Well Header",
    },
  },
  "formation_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Formation",
      "folder": "Well Header",
      "width": 200,
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Use this column for generic formation queries unless the user explicitly asks for basin, field, or another geologic grouping",
    },
  },
  "basin": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Basin",
      "folder": "Well Header",
    },
    "gpt": {
      "hint": "Use this field when the user explicitly asks for a basin, such as Permian or Williston. Do not substitute for formation unless basin is explicitly requested.",
    },
  },
  "field_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Field",
      "folder": "Well Header",
      "isShownByDefault": true,
    },
  },
  "district": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "District",
      "folder": "Well Header",
    },
  },
  "permit_granted_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Permit Date",
      "folder": "Well Header",
      "width": 110,
    },
  },
  "spud_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Spud Date",
      "folder": "Well Header",
      "width": 110,
      "isShownByDefault": true,
    },
  },
  "completion_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Completion Date",
      "folder": "Well Header",
    },
  },
  "production_first_prod_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "First Production Month",
      "folder": "Well Header",
    },
    "gpt": {
      "hint": "Date of the first reported production month",
    },
  },
  "production_last_prod_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Last Production Month",
      "folder": "Well Header",
    },
    "gpt": {
      "hint": "Date of the most recent reported production month. Use this for last production / inactive-since style queries.",
    },
  },
  "plug_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Plug Date",
      "folder": "Well Header",
    },
  },
  "current_well_count_on_lease": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Well Count on Lease",
      "folder": "Well Header",
    },
  },
  "total_measured_depth_ft": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "ft",
    },
    "ui": {
      "label": "TMD",
      "folder": "Well Header",
      "width": 120,
      "isShownByDefault": true,
    },
  },
  "total_vertical_depth_ft": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "ft",
    },
    "ui": {
      "label": "TVD",
      "folder": "Well Header",
      "width": 120,
      "isShownByDefault": true,
    },
  },
  "surface_latitude": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Surface Latitude",
      "folder": "Location",
    },
  },
  "surface_longitude": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Surface Longitude",
      "folder": "Location",
    },
  },
  "production_has_recent_prod": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Recent Production",
      "folder": "Production",
    },
    "gpt": {
      "hint": "Has production in the most recent reporting month available from the regulator (typically ~1 month behind current date)",
    },
  },
  "recent_oil": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl",
    },
    "ui": {
      "label": "Recent Oil",
      "folder": "Production",
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Oil production for the most recent reporting month available from the regulator (typically ~1 month behind current date)",
    },
  },
  "recent_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mcf",
    },
    "ui": {
      "label": "Recent Gas",
      "folder": "Production",
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Gas production for the most recent reporting month available from the regulator (typically ~1 month behind current date)",
    },
  },
  "symbol": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
    "gpt": {
      "exclude": true,
    },
  },
  "related_ids": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
    "gpt": {
      "exclude": true,
    },
  },
  "well_path_geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
    "gpt": {
      "exclude": true,
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
    "gpt": {
      "exclude": true,
    },
  },
}
